import React from 'react'

import { i18n } from '~/i18n'

import ProfileCreditsSummary from './profile-credits-summary'
import { nestProfileCredits } from './profiles-credits-summary.utils'

import type { ProfileIdentifier } from './profiles-credits-summary.types'
import type { ProfileProduct, SingleUseCredit } from '~/types'

type Props = {
  credits: SingleUseCredit[]
  disableCreditDetailsBackground?: boolean
  onReset?: (arg0: number) => Promise<void>
  profileProducts: ProfileProduct[]
  profiles: ProfileIdentifier[]
}

export default function ProfilesCreditsSummary({
  profiles,
  profileProducts,
  credits,
  disableCreditDetailsBackground,
  onReset,
}: Props) {
  const profilesWithCredits = nestProfileCredits({
    profiles,
    profileProducts,
    credits,
  })

  if (profilesWithCredits.length === 0) {
    return (
      <>{i18n.t('components.profiles_credits_summary.no_credit_available')}</>
    )
  }

  return (
    <>
      {profilesWithCredits.map((profileWithCredits) => (
        <ProfileCreditsSummary
          key={profileWithCredits.id}
          profileWithCredits={profileWithCredits}
          disableCreditDetailsBackground={disableCreditDetailsBackground}
          onReset={onReset}
        />
      ))}
    </>
  )
}
